import React, { useState } from 'react';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { PopupModal } from '../../../Modals/Index';
import { LabeledInput } from '../../../Components';
import './Style.css';
const Index = ({ email, state, setStateFalse }) => {
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');

    return (
        <PopupModal setStateFalse={setStateFalse} state={state}>
            <div className="popupConatiner">
                <div className="home_head flex-start">
                    <div className="home_head">
                        <div>
                            <h2 className="home_heading">Send mail to Merchant: {email}</h2>
                        </div>
                    </div>
                </div>
                <form className="mail-popup" action={`mailto:${email}`} method="post" enctype="text/plain">
                    <LabeledInput
                        style={{ width: '100%' }}
                        name="Subject"
                        value={subject}
                        changeHandler={(e) => {
                            setSubject(e.target.value);
                        }}
                        label={'Subject'}
                    />

                    <p className="mail-popup_textarea_label">You Message</p>
                    <textarea
                        className="mail-popup_textarea"
                        value={body}
                        onChange={(e) => {
                            setBody(e.target.value);
                        }}
                    />
                    <div className="mail-popup_footer">
                        <button
                            type="reset"
                            onClick={setStateFalse}
                            className="btn-gray"
                            style={{ marginRight: '1rem' }}
                        >
                            <KeyboardBackspaceIcon className="btn-icon" />
                            <p>Back</p>
                        </button>
                        <button type="submit" className="btn-orange">
                            <MailOutlineIcon className="btn-icon" />
                            <p>Send Mail</p>
                        </button>
                    </div>
                </form>
            </div>
        </PopupModal>
    );
};

export default Index;
